module.exports = __webpack_public_path__ + "media/components/src/assets/images/news/news_7-4883532b884ae9cb13c57536a3f742b8.jpg";